import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatMenu} from '@angular/material';
import { ProjectService } from '../services/project.service';


@Component({
  selector: 'projects',
  templateUrl: './projects.component.html',
  providers: [ProjectService]
  //styleUrls: ['./app.component.css']
})
export class ProjectsComponent implements OnInit{

  private isLoading:Boolean = true;
  projects = new Array();
  animal: string;
  name: string;
  title: string;
  description:string;

  constructor(public dialog: MatDialog, private projectService:ProjectService) {}

  ngOnInit(): void {
     this.projectService.getProjectsSlowly().then(data => (this.projects = data, this.isLoading = false));
  }

  openDialog(): void {
    let dialogRef = this.dialog.open(ProjectDialog, {
      width: '500px',
      data: { title:this.title, animal: this.animal }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed'+result);

      //this.animal = result;
      if (this.title = result) {
        this.projects.push({
          id: 6,
          title: this.title,
          color: 'green'
        })
      }


    });
  }

}

@Component({
  selector: 'project-dialog',
  templateUrl: 'project-dialog.html',
})
export class ProjectDialog {

  projComp;

  constructor(
    public dialogRef: MatDialogRef<ProjectDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  createProject() {
    console.log('Create New Project');
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /Library/WebServer/Documents/task-manager/src/app/projects/projects.component.ts